export { default as EmployeeEmojiRating } from './employee-emoji-rating'



// WEBPACK FOOTER //
// ./src/app/front-face/shared/employee-emoji-rating/index.ts